// ── 출퇴근 관리 ☰ 메뉴 (2026-09-29 사용자: 스위치 오른쪽 메뉴 아이콘 — 예외 스케줄 등록·시간 설정·엑셀 다운로드 순) ──
//   두 탭(달력·직원별 상세)이 같은 메뉴를 같은 자리에 그린다. 항목은 화면이 넘긴다(보던 달 등 화면 값이 필요해서).
//   열쇠가 없는 항목은 화면이 빼고 넘긴다 — 항목이 0개면 아이콘도 그리지 않는다.
//   차단형 모달 아님(드롭다운) — 스크롤 잠금 없이 투명 클릭아웃으로 닫는다(필터 팝오버와 같은 방식).
import React, { useState } from 'react';
import { Menu } from 'lucide-react';

const itemStyle = {
  display: 'block', width: '100%', textAlign: 'left', padding: '10px 14px', minHeight: 40,
  border: 0, background: 'transparent', color: 'var(--text)', fontSize: 13, fontWeight: 700, cursor: 'pointer',
};

/** @param {{key:string,label:string,onClick:function}[]} items */
export default function AttendanceMenu({ items = [] }) {
  const [open, setOpen] = useState(false);
  const list = items.filter(Boolean);
  if (list.length === 0) return null;
  return (
    <div className="no-print" style={{ position: 'relative', flexShrink: 0 }}>
      <button
        type="button"
        aria-label="메뉴"
        aria-haspopup="menu"
        aria-expanded={open}
        title="메뉴"
        onClick={() => setOpen((v) => !v)}
        style={{
          width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center',
          border: 0, borderRadius: 8, background: open ? 'var(--bg-subtle)' : 'transparent', color: 'var(--text)', cursor: 'pointer',
        }}
      >
        <Menu size={22} />
      </button>
      {open && (
        <>
          <div style={{ position: 'fixed', inset: 0, zIndex: 900 }} onClick={() => setOpen(false)} />
          <div role="menu" style={{
            position: 'absolute', top: 42, right: 0, zIndex: 901, minWidth: 180, padding: 6,
            background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 12,
            boxShadow: '0 12px 32px rgba(15,27,53,0.14)',
          }}>
            {list.map((it) => (
              <button
                key={it.key}
                type="button"
                role="menuitem"
                style={itemStyle}
                onMouseEnter={(e) => { e.currentTarget.style.background = 'var(--bg-subtle)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
                onClick={() => { setOpen(false); it.onClick(); }}
              >
                {it.label}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
